import { useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useCore } from "../../../shared/hooks/use-core";
import { formatFullDateTime } from "../../../shared/utils/format-date";
import { getOrderById } from "../mockOrders";
import { statusColor } from "../Orders/orderStatus";
import { OrderClientCard } from "./OrderClientCard";
import { OrderHistoryTimeline } from "./OrderHistoryTimeline";
import { OrderPaymentCard } from "./OrderPaymentCard";
import { OrderQueryCard } from "./OrderQueryCard";

export default function OrderDetail() {
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const backTo =
		(location.state as { from?: string } | null)?.from ?? "/pedidos";
	const { setTitleBar, setPathTitleBar } = useCore();
	const order = id ? getOrderById(id) : undefined;

	useLayoutEffect(() => {
		setTitleBar(order ? `Pedido ${order.orderNumber}` : "Pedido");
		setPathTitleBar(undefined);
	}, [setTitleBar, setPathTitleBar, order]);

	if (!order) {
		return (
			<Box>
				<Typography color="text.secondary">Pedido não encontrado.</Typography>
			</Box>
		);
	}

	return (
		<Box>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 2,
					flexWrap: "wrap",
					mb: 3,
				}}
			>
				<IconButton
					aria-label="Voltar para a lista de pedidos"
					onClick={() => navigate(backTo)}
				>
					<ArrowBackIcon />
				</IconButton>
				<Typography variant="h5">{order.orderNumber}</Typography>
				<Typography variant="body2" color="text.secondary">
					{formatFullDateTime(order.date)}
				</Typography>
				<Chip
					label={order.status}
					color={statusColor[order.status]}
					variant="filled"
				/>
			</Box>

			<Grid container spacing={2}>
				<Grid item xs={12} md={4}>
					<OrderClientCard order={order} />
				</Grid>
				<Grid item xs={12} md={4}>
					<OrderQueryCard order={order} />
				</Grid>
				<Grid item xs={12} md={4}>
					<OrderPaymentCard order={order} />
				</Grid>
				<Grid item xs={12}>
					<OrderHistoryTimeline history={order.history} />
				</Grid>
			</Grid>
		</Box>
	);
}
